import { QueryClient } from "@tanstack/react-query";

/**
 * The Toss API is REST-only with no streaming, and its per-client rate limits
 * are tight (ACCOUNT is 1 req/s). Everything the browser reads is proxied
 * through our API, which caches on our side — but the browser should still not
 * hammer it, so refetch-on-focus is off and stale windows are explicit per query
 * rather than inherited from a permissive default.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      gcTime: 5 * 60_000,
      refetchOnWindowFocus: false,
      retry: (failureCount, error) => {
        // Never retry a client error — a 4xx from our API means the request was
        // wrong or the Toss connection is broken, and retrying just burns the
        // user's rate-limit budget.
        const status = (error as { status?: number } | null)?.status;
        if (status && status >= 400 && status < 500) return false;
        return failureCount < 2;
      },
    },
    mutations: {
      retry: 0,
    },
  },
});
